import { privateClient } from '@lidea/shared/data-access/core';
import { User, UserPageResult } from '@lidea/shared/util/types';

type CreateData = Omit<User, 'id'> & {
  password: string;
};

type UpdateData = Partial<User> & {
  id: number;
};

type UpdateMeData = {
  old_password: string;
  new_password: string;
};

export const usersApi = {
  create: (data: CreateData) => {
    return privateClient.post('users/', { json: data }).json<User>();
  },
  list: ({
    page = 1,
    q,
    ordering,
  }: {
    page?: number;
    q?: string;
    ordering?: string;
  }) => {
    const searchParams: Record<string, string | number> = { page };
    if (q?.trim()) {
      searchParams.q = q.trim();
    }
    if (ordering) {
      searchParams.ordering = ordering;
    }
    return privateClient.get('users', { searchParams }).json<UserPageResult>();
  },
  getOne: (id: number) => {
    return privateClient.get(`users/${id}`).json<User>();
  },
  update: (data: UpdateData) => {
    const { id, ...rest } = data;
    return privateClient.patch(`users/${id}/`, { json: rest }).json<User>();
  },
  delete: (id: number) => {
    return privateClient.delete(`users/${id}`).json<User>();
  },
  getManagers: (data: { userId: number }) => {
    return privateClient.get(`users/${data.userId}/getsubs`).json<User[]>();
  },
  getRoles: (data: { userId: number }) => {
    return privateClient.get(`users/${data.userId}/roles`).json<string[]>();
  },
  me: () => {
    return privateClient.get(`me`).json<User>();
  },
  updateMe: (data: UpdateMeData) => {
    return privateClient.patch(`me/`, { json: data }).json<User>();
  },
};
